import { useState, useEffect } from 'react';
import axios from 'axios';
import Skeleton from 'react-loading-skeleton';
import { API_URL } from 'lib/network/api';

const getThumbnail = async (imagePath) => {
  try {
    const cacheBuster = new Date().getTime();
    const res = await axios.get(`${API_URL}/file?file_path=${imagePath}&_=${cacheBuster}`, {
      responseType: 'arraybuffer',
    });

    if (!res.headers['content-type'].startsWith('image')) {
      throw new Error('Invalid content type');
    }

    const arrayBufferView = new Uint8Array(res.data);
    const blob = new Blob([arrayBufferView], { type: res.headers['content-type'] });
    const imageUrl = URL.createObjectURL(blob);

    return imageUrl;
  } catch (error) {
    console.error('Failed to load image:', error);
    return '/kin/assest/image/icon-profile.png';
  }
};

const CardOurClassImage = ({ item, variant = 'card', costumeClass }) => {
  const [thumbnail, setThumbnail] = useState(null);
  const [loadingImage, setLoadingImage] = useState(true);

  const containerClass =
    variant === 'modal'
      ? 'h-56 w-full overflow-hidden rounded-2xl bg-gray-200 lg:h-64'
      : 'h-56 w-full overflow-hidden rounded-2xl bg-gray-200 lg:h-72 xl:h-80';

  useEffect(() => {
    const fetchThumbnail = async () => {
      if (item?.images?.length) {
        try {
          const url = await getThumbnail(item.images[0]);
          setThumbnail(url);
        } catch (error) {
          console.error('Error fetching image:', error);
          setThumbnail('/kin/assest/image/icon-profile.png');
        }
      } else {
        setThumbnail('/kin/assest/image/icon-profile.png');
      }
      setLoadingImage(false);
    };

    fetchThumbnail();
  }, [item]);

  return (
    <div className={costumeClass ? costumeClass : containerClass}>
      {loadingImage ? (
        <Skeleton height="100%" width="100%" className="rounded-2xl" />
      ) : (
        <img
          alt={item?.name}
          src={thumbnail}
          className="h-full w-full object-cover object-center transition-opacity duration-300"
        />
      )}
    </div>
  );
};

export default CardOurClassImage;
